import Tabs from "./tab";

export default Tabs;
